import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=35d232cb&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=35d232cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d232cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d232cb')) {
      api.createRecord('35d232cb', component.options)
    } else {
      api.reload('35d232cb', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=35d232cb&scoped=true&", function () {
      api.rerender('35d232cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xTK9ImJYlbc/JS/comp/GuestBox.vue"
export default component.exports